import { HttpContextToken } from '@angular/common/http';

export const IGNORE_REQUEST_ERROR_CODES = new HttpContextToken(() => []);
